import React from 'react';
import { format, parseISO } from 'date-fns';

const SEGMENT_LABELS = { ALL: 'Combined', STANDARD: 'Standard', TRUCKING: 'Trucking' };

const fmtDate = (d) => {
  if (!d) return '';
  try {
    return format(typeof d === 'string' ? parseISO(d) : d, 'MMMM d, yyyy');
  } catch {
    return '';
  }
};

/**
 * PFRS-for-SMEs income statement header block: client legal name, "Income
 * Statement — {segment}" subtitle, period line, and the peso-denomination note.
 */
const StatementHeader = ({ clientName, segment = 'ALL', startDate, endDate }) => {
  const segmentLabel = SEGMENT_LABELS[segment] || 'Combined';

  return (
    <div className="text-center mb-6">
      {clientName && <div className="text-lg font-medium text-ink mb-1">{clientName}</div>}
      <div className="text-xl font-medium text-ink">Income Statement — {segmentLabel}</div>
      <div className="text-sm text-ink-body mt-1">
        For the period {fmtDate(startDate)} to {fmtDate(endDate)}
      </div>
      <div className="text-xs text-ink-body mt-1">All amounts in Philippine peso (₱)</div>
    </div>
  );
};

export default StatementHeader;
